import axios from "axios";
import * as types from "../mutation-types";
import api from "@/api/api";

export const state = {
  listRemoteRequests: [],
  listApprovalRemoteRequests: [],
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  userInfo: {},
  requestInfo: {},
  approveInfo: {},
  countRemoteRequest: {},
};

// getters
export const getters = {
  listRemoteRequests: state => state.listRemoteRequests,
  listApprovalRemoteRequests: state => state.listApprovalRemoteRequests,
  pagination: state => state.pagination,
  userInfo: state => state.userInfo,
  requestInfo: state => state.requestInfo,
  approveInfo: state => state.approveInfo,
  countRemoteRequest: state => state.countRemoteRequest,
};

// mutations
export const mutations = {
  [types.REMOTE.REMOTE_REQUEST_LIST](state, data) {
    state.listRemoteRequests = data.remoteRequests;
    state.pagination.from = data.remoteRequests.from;
    state.pagination.to = data.remoteRequests.to;
    state.pagination.totalPage = data.remoteRequests.last_page;
    state.pagination.path = data.remoteRequests.path;
    state.pagination.currentPage = data.remoteRequests.current_page;
    state.pagination.totalRecord = data.remoteRequests.total;
    state.pagination.perPage = data.remoteRequests.per_page;
    state.countRemoteRequest = data.countRemoteRequest;
  },
  [types.REMOTE.REMOTE_APPROVAL_REQUEST_LIST](state, data) {
    state.listApprovalRemoteRequests = data.remoteRequests;
    state.pagination.from = data.remoteRequests.from;
    state.pagination.to = data.remoteRequests.to;
    state.pagination.totalPage = data.remoteRequests.last_page;
    state.pagination.path = data.remoteRequests.path;
    state.pagination.currentPage = data.remoteRequests.current_page;
    state.pagination.totalRecord = data.remoteRequests.total;
    state.pagination.perPage = data.remoteRequests.per_page;
    state.countRemoteRequest = data.countRemoteRequest;
  },
  [types.REMOTE.GET_USER_REMOTE_INFO](state, data) {
    state.userInfo = data;
  },
  [types.REMOTE.GET_USER_REMOTE_INFO](state, data) {
    state.userInfo = data;
  },
  [types.REMOTE.GET_REMOTE_REQUEST_INFO](state, data) {
    state.requestInfo = data;
  },
  [types.REMOTE.GET_APPROVAL_REMOTE_REQUEST_INFO](state, data) {
    state.approveInfo = data;
  },
  [types.REMOTE.CLEAR_DATA](state) {
    // state.pagination = {
    //   from: 0,
    //   to: 0,
    //   totalPage: 0,
    //   path: "",
    //   currentPage: 0,
    //   totalRecord: 0,
    //   perPage: 0
    // },
    state.userInfo = {};
    //   state.listRemoteRequests = [];
    //   state.requestInfo = {}
  },
};

// actions
export const actions = {
  async getUserRemoteInfo({commit}) {
    const response = await axios.get(api.REMOTE_MANAGEMENT.GET_USER_REMOTE_INFO);
    commit(types.REMOTE.GET_USER_REMOTE_INFO, response);
  },
  clearData({commit}) {
    commit(types.REMOTE.CLEAR_DATA);
  },
  async createRemoteRequest(_, params) {
    await axios.post(api.REMOTE_MANAGEMENT.CREATE_REMOTE_REQUEST, params);
  },
  async getRemoteRequestInfo({commit}, params) {
    const response = await axios.get(api.REMOTE_MANAGEMENT.GET_REMOTE_REQUEST_INFO.replace(":id", params));
    commit(types.REMOTE.GET_REMOTE_REQUEST_INFO, response);
  },
  /**
   * Get list mine remote request
   *
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>|{err}>}
   */
  async getListMineRemoteRequest({commit}, payload) {
    try {
      const response = await axios.get(api.REMOTE_MANAGEMENT.REMOTE_LIST, {
        params: {
          per_page: payload.itemsPerPage,
          page: payload.currentPage,
          start_date: payload.start_date,
          end_date: payload.end_date,
          status: payload.status,
          month: payload.month
        }
      });
      commit(types.REMOTE.REMOTE_REQUEST_LIST, response.data);
      return response.data.remoteRequests;
    } catch (err) {
      return {err};
    }
  },
  /**
   * Get list approval remote request
   *
   * @param commit
   * @param payload
   * @returns {Promise<string|default.watch.remoteRequests|*|{err}>}
   */
  async getListApprovalRequestRemote({commit}, payload) {
    try {
      const response = await axios.get(api.REMOTE_MANAGEMENT.REMOTE_APPROVAL_LIST, {
        params: {
          employee_info: payload.employee_info,
          approveStatus: payload.approve_status,
          per_page: payload.itemsPerPage,
          page: payload.currentPage,
          start_date: payload.start_date,
          end_date: payload.end_date,
          status: payload.status,
          month: payload.month
        }
      });
      commit(types.REMOTE.REMOTE_APPROVAL_REQUEST_LIST, response.data);
      return response.data.remoteRequests;
    } catch (err) {
      return {err};
    }
  },
  /**
   * Delete remote request.
   *
   * @param commit
   * @param id
   * @returns {Promise<{error}|AxiosResponse<any>|boolean>}
   */
  // eslint-disable-next-line no-unused-vars
  async deleteRemoteRequest({commit}, id) {
    const res = await axios.delete(
      api.REMOTE_MANAGEMENT.DELETE_REMOTE_REQUEST.replace(":id", id)
    );
    if (res.error) {
      return res;
    }
    return false;
  },
  async updateRemoteRequest(_, params) {
    await axios.post(api.REMOTE_MANAGEMENT.EDIT_REMOTE_REQUEST_INFO.replace(":id", params.id), params);
  },
  async getApprovalRemoteRequestInfo({commit}, params) {
    try {
      const response = await axios.get(api.REMOTE_MANAGEMENT.GET_APPROVAL_REMOTE_REQUEST_INFO.replace(":id", params));
      commit(types.REMOTE.GET_APPROVAL_REMOTE_REQUEST_INFO, response);
      return response;
    } catch (err) {
      return {err};
    }
  },
  async approveRemoteRequest(_, params) {
    const response = await axios.post(api.REMOTE_MANAGEMENT.APPROVE_REMOTE_REQUEST.replace(":id", params.id), params);
  },
};
